import { subscriptionExchange } from 'urql';
import { createUrqlWsClient } from '../wsClient';

let wsClient = createUrqlWsClient();

export function resetSubscriptionClient() {
  wsClient.dispose();
  wsClient = createUrqlWsClient();
}

export default subscriptionExchange({
  forwardSubscription(request) {
    const input = { ...request, query: request.query || '' };

    return {
      subscribe: (sink) => ({
        unsubscribe: wsClient.subscribe(input, sink),
      }),
    };
  },
});
